import React from 'react';
import invert from 'lodash/invert';
import upperFirst from 'lodash/upperFirst';
import { useTranslate } from '@im/react-localization';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Tag, TagProps } from '@im/ui-lib/Tag';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { EDStatus, ExceptionBidStatus } from '../../hooks/exceptionDeal';

export function VerificationStatus(prop: any) {
  const item = prop.item;
  const functi_all = () => {
    switch (item.value) {
      case 'Success':
        return (
          <Tag
            endIcon={<CheckCircleOutlineIcon />}
            label={item.value}
            sx={{
              width: '150px',
            }}
            variant="success"
          />
        );
      case 'Failed':
      case 'Partially Successful':
        return (
          <Tag
            endIcon={<CancelOutlinedIcon />}
            label={item.value}
            sx={{
              width: '150px',
            }}
            variant="error"
          />
        );
      case 'Timeout':
        return (
          <Tag
            endIcon={<ErrorOutlineOutlinedIcon />}
            label={item.value}
            sx={{
              width: '150px',
            }}
            variant="info"
          />
        );
      default:
        return (
          <Stack spacing={1}>
            <Tag
              endIcon={<AccessTimeOutlinedIcon />}
              label={item.value ? item.value.slice(0, 11) : ''}
              sx={{
                width: '150px',
              }}
              variant="warning"
            />
            <Typography
              sx={(theme) => ({
                color: theme.palette.grey[800],
                fontSize: theme.typography.body2.fontSize,
                fontWeight: theme.typography.fontWeightSemiBold,
                lineHeight: theme.typography.body2.lineHeight,
                width: '137px',
              })}
            >
              {item.value ? item.value.slice(12) : ''}
            </Typography>
          </Stack>
        );
    }
  };
  return functi_all();
}

export const getExceptionDealTagVariant = (
  status: ExceptionBidStatus,
  role: 'admin' | 'other'
) => {
  const variantMap = {
    admin: {
      [EDStatus.PENDING_REVIEW]: 'purple1',
      [EDStatus.NEW]: 'info',
      [EDStatus.APPROVED]: false,
      [EDStatus.COMPLETED]: false,
    } as any,
    other: {
      [EDStatus.PENDING_REVIEW]: 'success',
      [EDStatus.NEW]: 'purple1',
      [EDStatus.APPROVED]: false,
      [EDStatus.REJECTED]: 'warning',
      [EDStatus.COMPLETED]: false,
    } as any,
  };
  const variant = variantMap[role][status] ?? 'error';
  return (
    typeof variant === 'string' ? variant : undefined
  ) as TagProps['variant'];
};

export const EDVerificationStatus = ({ item: status, role: isAdmin }: any) => {
  const translate = useTranslate();
  const role = isAdmin ? 'admin' : 'other';
  const variant = getExceptionDealTagVariant(status, role);
  const label = translate(
    `ExceptionDeals.Status${upperFirst(role)}${invert(EDStatus)[status]}`
  );
  const tagProps = {
    label,
    ...(variant && { variant }),
  };

  return <Tag {...tagProps} />;
};
